import get from './get';
import disableMessage from './disableMessage';
import getThreads from './getThreads';
import getThreadDetail from './getThreadDetail';
import saveReminder from './saveReminder';
import getAirbnbMessageForSpecifiedBooking from './getAirbnbMessageForSpecifiedBooking';
import getSmsSent from './getSmsSent';
import getReplacedShortCodesText from './getReplacedShortCodesText';
import markMessageAsRead from "./markMessageAsRead";
import sendSms from './sendSms';
import tagMessages from "./tagMessages";
import getNew from "./get-new";

export default {
  get,
  disableMessage,
  getThreads,
  getThreadDetail,
  saveReminder,
  getAirbnbMessageForSpecifiedBooking,
  getSmsSent,
  getReplacedShortCodesText,
  markMessageAsRead,
  sendSms,
  tagMessages,
  getNew
};



// WEBPACK FOOTER //
// ./src/app/services/message/index.js